
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lng]/faqs",
      function () {
        return require("private-next-pages/[lng]/faqs.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lng]/faqs"])
      });
    }
  